import type { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

export const languageInterceptor: HttpInterceptorFn = (request, next) => {
    const translocoService = inject(TranslocoService);

    return next(request.clone({ headers: request.headers.set("Accept-Language", translocoService.getDefaultLang()) }));
};
